module.exports = __webpack_public_path__ + "img/paypal.774f03d8.png";